import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box, useScrollTrigger } from '@mui/material';
import Fab from '@mui/material/Fab';
import Fade from '@mui/material/Fade';
import { useEffect } from 'react';
import { WsColors } from 'wisestep-base';

const BackToTop = () => {
  const trigger = useScrollTrigger({
    target: window ? window : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);
  return (
    <Box>
      <Fade in={trigger}>
        <Fab
          size="large"
          aria-label="scroll back to top"
          onClick={() => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          }}
          sx={{
            '&:hover': {
              backgroundColor: WsColors.TertiaryShades100,
              borderColor: WsColors.TertiaryShades100,
            },
          }}
          style={{
            display: 'inline-block',
            position: 'fixed',
            bottom: '15px',
            right: '10px',
          }}
        >
          <KeyboardArrowUpIcon color="primary" sx={{ fontSize: '50px' }} />
        </Fab>
      </Fade>
    </Box>
  );
};
export default BackToTop;
